export { 
    sendeErgebnisanzeigeUpdateEvent
};

const ERGEBNISANZEIGE_UPDATE_EVENT = "sbe.suche.ergebnisanzeige.update";

class SucheErgebnisanzeige extends HTMLElement {
    constructor() {
        super();
        document.addEventListener(ERGEBNISANZEIGE_UPDATE_EVENT, (event) => {
            this.ergebnisanzeigeUpdateHandler(event);
        });
    }

    ergebnisanzeigeUpdateHandler(event) {
        const sichtbareArtikel = this.querySelector(".sichtbare-artikel");
        const anzahlTreffer = this.querySelector(".anzahl-treffer");
        const { value, lastPage } = event.detail;
        sichtbareArtikel.innerHTML = parseInt(value);
        if (lastPage) {
            anzahlTreffer.innerHTML = parseInt(value);
        }
    }
}

if (!customElements.get("suche-ergebnisanzeige")) {
    customElements.define("suche-ergebnisanzeige", SucheErgebnisanzeige);
}

function sendeErgebnisanzeigeUpdateEvent(value, lastPage = false) {
    document.dispatchEvent(
        new CustomEvent(ERGEBNISANZEIGE_UPDATE_EVENT, {
            bubbles: true,
            detail: {
                value: value,
                lastPage: lastPage
            }
        })
    );
}
